import React from 'react';
import { Clock } from 'lucide-react';

interface PrimeNuitConfigProps {
  config: {
    nuitsParMois: number;
  };
  onChange: (config: { nuitsParMois?: number }) => void;
  currentIndiceMajore?: number | null;
}

export default function PrimeNuitConfig({ config, onChange, currentIndiceMajore }: PrimeNuitConfigProps) {
  const handleNuitsChange = (nuitsParMois: number) => {
    onChange({ nuitsParMois });
  };

  const calculatePrimeAmount = () => {
    if (!currentIndiceMajore || config.nuitsParMois === 0) return 0;
    const salaireMensuel = currentIndiceMajore * 4.92278;
    const majoration = salaireMensuel * 0.25;
    const prorata = config.nuitsParMois / 30;
    return majoration * prorata;
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          <Clock className="w-4 h-4 inline mr-1" />
          Nombre de nuits travaillées par mois
        </label>
        <div className="flex items-center gap-2">
          <input
            type="number"
            value={config.nuitsParMois}
            onChange={(e) => {
              e.stopPropagation();
              handleNuitsChange(Number(e.target.value));
            }}
            onClick={(e) => e.stopPropagation()}
            onFocus={(e) => e.stopPropagation()}
            min="0"
            max="31"
            step="1"
            className="w-20 px-2 py-1 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <span className="text-sm text-gray-600">nuits</span>
        </div>
        <div className="mt-2 text-xs text-gray-500">
          Maximum : 31 nuits par mois
        </div>
      </div>
    </div>
  );
}